// src/components/UserMenu.jsx
import React, { useState } from "react";
import UserTable from "./UserTable";

function UserMenu({ user, onLogout }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const toggleMenu = () => setShowMenu(!showMenu);
  const toggleTable = () => setShowTable(!showTable);

  return (
    <div style={{ position: "absolute", top: 10, right: 10, zIndex: 200 }}>
      {/* Recuadro con correo */}
      <div
        onClick={toggleMenu}
        style={{
          backgroundColor: "#f5f5f5",
          padding: "10px 15px",
          borderRadius: "20px",
          boxShadow: "0 0 5px rgba(0,0,0,0.2)",
          cursor: "pointer",
          fontWeight: "500",
        }}
      >
        {user?.correo || "Usuario"}
      </div>

      {/* Menú desplegable */}
      {showMenu && (
        <div
          style={{
            position: "absolute",
            right: 0,
            marginTop: "5px",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            padding: "10px",
            minWidth: "160px",
            textAlign: "left",
            zIndex: 300,
          }}
        >
          {user.role === "admin" && (
            <button
              onClick={toggleTable}
              style={{
                display: "block",
                width: "100%",
                backgroundColor: "#007bff",
                color: "white",
                padding: "8px",
                border: "none",
                borderRadius: "6px",
                marginBottom: "5px",
                cursor: "pointer",
              }}
            >
              Gestionar usuarios
            </button>
          )}
          <button
            onClick={onLogout}
            style={{
              display: "block",
              width: "100%",
              backgroundColor: "#dc3545",
              color: "white",
              padding: "8px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Cerrar sesión
          </button>
        </div>
      )}

      {/* Tabla de gestión (solo para admin) */}
      {showTable && user.role === "admin" && (
        <UserTable onClose={() => setShowTable(false)} />
      )}
    </div>
  );
}

export default UserMenu;